export const environment = {
  production: true,
  baseApiUrl: 'https://api-t.rw3.app/',
  baseAppUrl: 'https://app-t.rw3.app/',
  env: 'test'
};
